import './index.css'

function PageNavigator({ numberSelected }) {
    const items = [
        { src: './images/home.png', text: 'Your feed',url: '/feed' },
        { src: './images/lightbulb.png', text: 'Your ideas',url: '/ideas' },
        { src: './images/calendar.png', text: 'Your schedule',url: '/schedule' },
        { src: './images/scan.png', text: 'Your sites',url: '/sites' },
        { src: './images/settings.png', text: 'Settings',url: '/settings' },

    ];

    return (
        <div className='nav-holder'>
        <div className='page-navigator'>
            {items.map((item, index) => (
                <a href={item.url}><div
                    key={index}
                    className={`navigation-item ${numberSelected === index ? 'selected-nav-item' : ''}`}
                >
                    <div className='navigation-item-icon-holder'>
                        <img className='navigation-item-icon' src={item.src} alt={item.text} />
                    </div>
                    <div className='navigation-item-text small-text'>{item.text}</div>
                </div></a>
            ))}
        </div>
        </div>
    );
}

export default PageNavigator;